import DocumentsApi from '../../../api/Documents'
import { EmployeeLoanApi } from '../../../api/People/EmployeeLoan'
import EmployeeLoan from '../../../components/People/EmployeeLoan/EmployeeLoan'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { isEmpty, pick } from 'lodash'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import { message } from 'antd'

const docsApi = new DocumentsApi()

function EmployeeLoanCont() {
  const { list, fetching, fetch } = useFetchList(() => EmployeeLoanApi.list())

  const {
    visible,
    modalType,
    object: employeeLoan,
    setObject: setEmployeeLoan,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(EmployeeLoanApi.create, EmployeeLoanApi.update, EmployeeLoanApi.remove, fetch)

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('loan', employeeLoan.status),
    [employeeLoan.status, isEmpty(employeeLoan.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(EmployeeLoanApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const LoanDB = await submitOperation({
      status: operation,
      ...pick(employeeLoan, ['_key', '_rev', '_id']),
    })
    if (LoanDB) setEmployeeLoan(LoanDB)
    hide()
  }

  return (
    <EmployeeLoan
      {...{
        list,
        fetching,
        submitting,
        visible,
        fetch,
        employeeLoan,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
      }}
    />
  )
}

export default EmployeeLoanCont
